import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from 'react-modal'; // Ensure you have react-modal installed
import './ProductPopup.css'; // Import custom CSS
import OrderEditExistingProduct from "../sales/orders/orders-single/order-components/orderEditExistingProduct/OrderEditExistingProduct"; // Updated progress bar



function ProductPopup({ popupMode, onRequestClose, productId, orderData, instanceUniqueId, handleSaveProduct, lookupType  }) {
  const [product, setProduct] = useState(null);
  const [markupPrice, setMarkupPrice] = useState(0);
  const [percentageIncrease, setPercentageIncrease] = useState(40); // Default 40% 
  const [baseIncrease, setBaseIncrease] = useState(0); // Fixed increase amount
  const [selectedColor, setSelectedColor] = useState('');
  const [selectedSize, setSelectedSize] = useState('');
  const [category, setCategory] = useState('');
  const [brand, setBrand] = useState('');
  const [tags, setTags] = useState('');
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('imprint');
  const [activeProductTab, setActiveProductTab] = useState('edit');

  const [activeTabs, setActiveTabs] = useState({
    optionIndex: null,
    groupIndex: null, 
    chargeIndex: null
  });
  // Handler to switch tabs for a specific group
  const handleTabChange = (optionIndex, groupIndex, chargeIndex) => {
    setActiveTabs({
      optionIndex,
      groupIndex,
      chargeIndex
    });
  };

  const [isTransitioning, setIsTransitioning] = useState(false);

  // Buffer time in milliseconds between image transitions
  const TRANSITION_DELAY = 500; // half a second buffer

  const handlePrevClick = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setActiveImageIndex((prevIndex) =>
        prevIndex === 0 ? product.Images.length - 1 : prevIndex - 1
      );
      setTimeout(() => setIsTransitioning(false), TRANSITION_DELAY);
    }
  };

  // Handle next image navigation
  const handleNextClick = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setActiveImageIndex((prevIndex) =>
        prevIndex === product.Images.length - 1 ? 0 : prevIndex + 1
      );
      setTimeout(() => setIsTransitioning(false), TRANSITION_DELAY);
    }
  };

useEffect(() => {
  if (!popupMode) return;

  if (popupMode === 'newprod') {
    setActiveProductTab('newprod');
    setProduct(null);
    return;
  }

  if (popupMode === 'edit') {
    setActiveProductTab('edit');

    if (!productId) return;

    const fetchProductDetails = async () => {
      try {
        let endpoint = "";
        alert("Searching")
        // If the productId is an object with a custom flag or mode
        const isCustom = productId?.isCustom || lookupType === 'custom';

        if (isCustom) {
          endpoint = `/products/retrieve-custom-product/${productId.ProductId}`;
        } else {
          endpoint = `/products/get-product/${productId.ProductId}`;
        }

        const { data } = await axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}${endpoint}`);
        const mergedProduct = { ...orderData, ...data };
        setProduct(mergedProduct);
      } catch (err) {
        alert("err: " + err)
        console.error("Error fetching product details:", err);
      }
    };

    fetchProductDetails();
  }
}, [popupMode, productId, lookupType]);


  const calculateCharges = (charges, quantity, imprintCode) => {
    if (!charges || !imprintCode) return 0;
  
    // Find all charges that match the imprint code and are either RNCH or OTCH
    const applicableCharges = charges
      .filter(charge => charge.TypeCode === imprintCode || charge.TypeCode === 'RNCH' || charge.TypeCode === 'OTCH')
      .flatMap(charge => charge.Prices || []);
  
    let totalCharge = 0;
  
    applicableCharges.forEach(price => {
      if (price.Quantity.From <= quantity &&
          (price.Quantity.To === 2147483647 || price.Quantity.To >= quantity)) {
        totalCharge += price.Price;
      }
    });
  
    return totalCharge;
  };
  
  
  const renderImprintTables = (prices) => {
    const imprintMethods = product?.Imprinting?.Methods?.Values || [];
  
    // Filter out null or undefined charges
    const allCharges = imprintMethods
      .flatMap(method => method.Charges || [])
      .filter(charge => charge != null);
  
    if (!Array.isArray(prices) || prices.length === 0) {
      return <strong>Imprinting + Variants coming soon</strong>;
    }
  
    // Create a mapping of imprint methods by Code for easier access
    const methodMap = imprintMethods.reduce((acc, method) => {
      acc[method.Code] = method;
      return acc;
    }, {});
  
    return Object.keys(methodMap).map((code) => {
      const method = methodMap[code];
      const methodCharges = method.Charges || [];
  
      // Check if the method is unimprinted by its name or any other identifier
      const isUnimprinted = method.Name?.toLowerCase().includes('unimprinted');
  
      return (
        <div key={code} className="imprint-table">
          <h4>{method.Name} Pricing</h4>
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Quantity</th>
                <th>Base Price</th>
                <th>Total Price</th>
              </tr>
            </thead>
            <tbody>
              {prices.map((price, index) => (
                <tr key={index}>
                  <td>{price.Quantity?.From || 'N/A'}+</td>
                  {/* Base product price */}
                  <td>${price.Price.toFixed(2)}</td>
                  {/* Total price: Base price + calculated charges (RNCH + OTCH) */}
                  <td>
                    ${(
                      price.Price +
                      calculateCharges(allCharges, price.Quantity?.From || 1, code)
                    ).toFixed(2)}
                    {/* Show additional charge details if applicable */}
                    {!isUnimprinted && calculateCharges(allCharges, price.Quantity?.From || 1, code) > 0 && (
                      <span className="imprinting-charge-notice">
                        {' '} (Additional charges applied)
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {methodCharges.length > 0 && (
            <div className="charges-details">
              <h5>Additional Charges</h5>
              <ul>
                {methodCharges.map((charge, index) => (
                  <li key={index}>
                    {charge.Type}: {charge.Description} - ${charge.Prices[0]?.Price.toFixed(2)}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      );
    });
  };
  
  const [products, setProducts] = useState([
    {
      id: 1,
      name: "Product A",
      markupPrice: 10,
      percentageIncrease: 15,
      baseIncrease: 5,
      selectedColor: "Red",
      selectedSize: "M",
      category: "Clothing",
      brand: "BrandX",
      tags: "Tag1,Tag2",
    },
    // Add more dummy products as needed
  ]);
  const [activeProduct, setActiveProduct] = useState({
    selectedImprintMethod: "", // Default: no imprinting
    selectedImprintColor: "",  // Default: no color selected
    selectedImprintSize: "",   // Default: no size selected
    selectedImprintLocation: "", // Default: no location selected
    selectedImprintNotes: "",  // Default: no additional notes
    imprintFile: null,         // Default: no file uploaded
    selectedQuantity: 1,       // Default quantity to 1
  }); // Currently selected product

  // Handlers for form fields
  const handleInputChange = (field, value) => {
    setActiveProduct((prev) => ({
      ...prev,
      [field]: value,
    }));
  };



  const handleCreateProduct = async () => {
    if (!product) return;
    const isCustomProduct = activeTab === 'customize';
    let productAttachedId
    if(isCustomProduct == false){
      productAttachedId = 'global'
    } else {
      productAttachedId = instanceUniqueId
    }
    try {
      console.log(JSON.stringify(product.Prices))
      await axios.post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/products/create-product`, {
        InstanceUniqueIds: [productAttachedId], // Ensure this is an array
        AsiId: product.Id,
        IsCustomProduct: isCustomProduct, // If you need to determine this value
        Name: product.Name,
        Description: product.Description,
        ShortDescription: product.ShortDescription,
        Number: product.Number,
        ImageUrl: product.ImageUrl,
        Images: product.Images, // Ensure this is an array if applicable
        VirtualSampleImages: product.VirtualSampleImages, // Ensure this is an array if applicable
        Supplier: product.Supplier, // Ensure this matches your model
        Categories: product.Categories, // Ensure this is an array if applicable
        Themes: product.Themes, // Ensure this is an array if applicable
        Origin: product.Origin, // Ensure this is an array if applicable
        TradeNames: product.TradeNames, // Ensure this is an array if applicable
        ProductionTime: product.ProductionTime, // Ensure this matches your model
        RushTime: product.RushTime, // Ensure this matches your model
        Attributes: product.Attributes, // Ensure this matches your model
        Imprinting: product.Imprinting, // Ensure this matches your model
        Options: product.Options, // Ensure this is an array if applicable
        Prices: product.Prices, // Ensure this matches your model
        Shipping: product.Shipping, // Ensure this matches your model
        Variants: product.Variants, // Ensure this is an array if applicable
        Warnings: product.Warnings, // Ensure this is an array if applicable
        HasHazardMaterial: product.HasHazardMaterial,
        Prop65AdditionalInfo: product.Prop65AdditionalInfo,
        Currencies: product.Currencies, // Ensure this is an array if applicable
        LowestPrice: product.LowestPrice, // Ensure this matches your model
        HighestPrice: product.HighestPrice, // Ensure this matches your model
        IsNew: product.IsNew,
        IsTrending: product.IsTrending,
        IsConfirmed: product.IsConfirmed,
        HasFullColorProcess: product.HasFullColorProcess,
        HasRushService: product.HasRushService,
        DistributorComments: product.DistributorComments,
        AdditionalInfo: product.AdditionalInfo,
        UpdateDate: product.UpdateDate,
        Sku: product.Sku, // Ensure this is an array if applicable
        IsAssembled: product.IsAssembled,
        HasInventory: product.HasInventory,
        Services: product.Services // Ensure this is an array if applicable
      });
      onRequestClose();
    } catch (error) {
      alert(JSON.stringify(error))
      console.error('Error creating product:', error);
    }
  };

  // Function to calculate updated base price with percentage and base increase
  const calculateUpdatedPrice = (basePrice) => {
    if (!basePrice) return 0;
    const percentageAdjustment = (basePrice * percentageIncrease) / 100;
    return (parseFloat(basePrice) + parseFloat(percentageAdjustment) + parseFloat(baseIncrease)).toFixed(2);
  };

  const renderVariantTable = (variant) => {
    return (
      <>



        <p>Variations available</p>
        <div key={variant.Id} className="variant-table">
          <h3>{variant.Name}</h3>
          <img src={`https://api.asicentral.com/v1/${variant.ImageUrl}?size=normal`} alt={variant.Name} className="variant-image" />
          <p>{variant.Description}</p>
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Quantity</th>
                <th>Price (USD)</th>
              </tr>
            </thead>
            <tbody>
              {variant.Prices.sort((a, b) => b.Quantity.From - a.Quantity.From).map((price, index) => (
                <tr key={index}>
                  <td>{price.Quantity.From} - {price.Quantity.To === 2147483647 ? 'Above' : price.Quantity.To}</td>
                  <td>${price.Price?.toFixed(2) || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const renderPricingTable = () => {
    if (product?.Variants && product.Variants.length > 0) {
      // Render the variants tables if they exist
      return product.Variants.map(renderVariantTable);
    } else if (product?.Prices && product.Prices.length > 0) {
      // Render the pricing table from Prices array
      return (
        <>
        <p>Pricing matrix (Purchase more products for a cheaper rate)</p>
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Quantity</th>
                <th>Price (USD)</th>
                <th>Price with Charges (USD)</th>
              </tr>
            </thead>
            <tbody>
              {product.Prices.sort((a, b) => b.Quantity.From - a.Quantity.From).map((price, index) => {
                const imprintCharge = product?.Imprinting?.Methods?.Values?.[0]?.Name; // Use the appropriate method name or calculation
                const additionalCharge = imprintCharge ? calculateCharges(product?.Charges, price.Quantity.From, imprintCharge) : 0;
    
                return (
                  <tr key={index}>
                    <td>{price.Quantity.From} - {price.Quantity.To === 2147483647 ? 'Above' : price.Quantity.To}</td>
                    <td>${price.Price?.toFixed(2) || 'N/A'}</td>
                    <td>${(price.Price + additionalCharge).toFixed(2)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      );
    } else if (product?.LowestPrice && product?.HighestPrice) {
      // Render the pricing breakdown using LowestPrice and HighestPrice
      return (
        <>
          <p>Lowest price/Highest price</p>
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Quantity</th>
                <th>Price (USD)</th>
                <th>Price with Charges (USD)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>(Lowest Price) {product.LowestPrice.Quantity.From} - {product.LowestPrice.Quantity.To === 2147483647 ? 'Above' : product.LowestPrice.Quantity.To}</td>
                <td>${product.LowestPrice.Price?.toFixed(2) || 'N/A'}</td>
                <td>${(product.LowestPrice.Price + calculateCharges(product?.Charges, product.LowestPrice.Quantity.From, 'Default Method')).toFixed(2)}</td> {/* Adjust method name */}
              </tr>
              <tr>
                <td>(Highest Price) {product.HighestPrice.Quantity.From} - {product.HighestPrice.Quantity.To === 2147483647 ? 'Above' : product.HighestPrice.Quantity.To}</td>
                <td>${product.HighestPrice.Price?.toFixed(2) || 'N/A'}</td>
                <td>${(product.HighestPrice.Price + calculateCharges(product?.Charges, product.HighestPrice.Quantity.From, 'Default Method')).toFixed(2)}</td> {/* Adjust method name */}
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      // Render a message or nothing if no pricing information is available
      return <p>No pricing information available.</p>;
    }
  };
  

  const renderTabContent = () => {
    switch (activeTab) {
      case 'pricing':
        return (
          <div className="tab-content">
            <h2>Pricing Breakdown</h2>
            {renderPricingTable()}
          </div>
        );
      case 'product-detail':
        return (
          <div className="tab-content">

            <div className="product-gallery">
              {product.Images && product.Images.length > 0 ? (
                <div className="slideshow-container">
                  {/* Previous Arrow */}
                  <button
                    className={`prev-arrow ${isTransitioning ? 'arrow-disabled' : ''}`}
                    onClick={handlePrevClick}
                  >
                    &#10094;
                  </button>

                  {/* Display Active Image */}
                  <div className="slideshow-image">
                    <img
                      src={`https://api.asicentral.com/v1/${product.Images[activeImageIndex]}?size=normal`}
                      alt={`Image ${activeImageIndex + 1} of ${product.Name}`}
                    />
                  </div>

                  {/* Next Arrow */}
                  <button
                    className={`next-arrow ${isTransitioning ? 'arrow-disabled' : ''}`}
                    onClick={handleNextClick}
                  >
                    &#10095;
                  </button>
                </div>
              ) : (
                <img
                  src={`https://api.asicentral.com/v1/${product.ImageUrl}?size=normal`}
                  alt={product.Name}
                  className="product-image"
                />
              )}
            </div>


            <h2>{product.Name}</h2>
            <p>{product.ShortDescription}</p>
            <p><strong>Supplier:</strong> {product.Supplier?.Name} (<a href={product.Supplier?.Websites?.[0]} target="_blank" rel="noopener noreferrer">Visit Website</a>)</p>
            {product.ProductionTime && product.ProductionTime.length > 0 && (
              <>
                <p><strong>Production Time:</strong></p>
                <ul>
                  {product.ProductionTime.map((time, index) => (
                    <li key={index}>
                      {time.Name ? time.Name : `${time.Days} days`}
                      {time.Description && ` - ${time.Description}`}
                    </li>
                  ))}
                </ul>
              </>
            )}
            {/* Check if RushTime exists and map through it */}
            {product.RushTime && product.RushTime.length > 0 && (
              <>
                <p><strong>Rush Time:</strong></p>
                <ul>
                  {product.RushTime.map((rush, index) => (
                    <li key={index}>
                      {rush.Name ? rush.Name : `${rush.Days} days`}
                      {rush.Description && ` - ${rush.Description}`}
                    </li>
                  ))}
                </ul>
              </>
            )}

            <p><strong>Rush Time:</strong> {product.RushTime?.[0]?.Days} days</p>
            <p><strong>Available Colors:</strong> {product.Attributes?.Colors?.Values?.map(color => color.Name).join(', ')}</p>
            <p><strong>Available Sizes:</strong> {product.Attributes?.Sizes?.Values?.map(size => size.Name).join(', ')}</p>
            <p className={product.HasInventory ? 'in-stock' : 'out-of-stock'}>
              {product.HasInventory ? 'In Stock' : 'Out of Stock'}
            </p>
            {product.Warnings?.[0]?.Warning && (
              <p className="warning"><strong>Warning:</strong> {product.Warnings[0].Warning}</p>
            )}
          </div>
        );
      case 'imprint':
        return (
          <div className="tab-content">
            <h2>Imprinting Breakdown</h2>
      
            {/* Check if Sold Unimprinted */}
            {product?.Imprinting?.SoldUnimprinted ? (
              <div>
                <p>This product is sold unimprinted.</p>
              </div>
            ) : (
              <div>
                <p>This product requires an imprint.</p>
              </div>
            )}
      
            {/* Display Colors */}
            {product?.Imprinting?.Colors?.Values && (
              <div>
                <h4>Available Colors</h4>
                <ul>
                  {product.Imprinting.Colors.Values.map((color, index) => (
                    <li key={index}>
                      {color.Name} {color.VendorCode ? `(Vendor Code: ${color.VendorCode})` : ''}
                    </li>
                  ))}
                </ul>
              </div>
            )}
      
            {/* Display Sizes */}
            {product?.Imprinting?.Sizes?.Values && (
              <div>
                <h4>Available Sizes</h4>
                <ul>
                  {product.Imprinting.Sizes.Values.map((size, index) => (
                    <li key={index}>
                      {size.Name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
      
            {/* Display Locations */}
            {product?.Imprinting?.Locations?.Values && (
              <div>
                <h4>Imprint Locations</h4>
                <ul>
                  {product.Imprinting.Locations.Values.map((location, index) => (
                    <li key={index}>
                      {typeof location === 'string' ? location : location.Name}
                      {location?.VendorCode ? ` (Vendor Code: ${location.VendorCode})` : ''}
                    </li>
                  ))}
                </ul>
              </div>
            )}
      
{/* Display Additional Options */}
{product?.Imprinting?.Options && (
  <div>
    <h4>Additional Imprinting Options</h4>

    {/* Main Options Table */}
    <table className="pricing-table">
      <thead>
        <tr>
          <th>Option Name</th>
          <th>Type</th>
          <th>Values</th>
          <th>Quantity From</th>
          <th>Quantity To</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
        {product.Imprinting.Options.map((option, index) => (
          <>
            {/* Main row with Option details */}
            <tr key={index}>
              <td>{option.Name}</td>
              {option.Charges?.[0]?.Prices.map((price, priceIndex) => (
                <>
                  <td>{option.Charges?.[0]?.Type || 'N/A'}</td>
                  <td>{option.Values ? option.Values.join(', ') : 'No values'}</td>
                  <td>{price.Quantity.From}</td>
                  <td>{price.Quantity.To !== 2147483647 ? price.Quantity.To : 'Max Quantity'}</td>
                  <td>${price.Price}</td>
                </>
              ))}
              {/* If the option has groups, display "Look at charts below" */}
              {option.Groups && (
                <td colSpan="5">Look at charts below</td>
              )}
            </tr>

            {/* Prices Rows */}
          </>
        ))}
      </tbody>
    </table>

    {/* Additional Tables for 'Groups' if exist */}
    {product.Imprinting.Options.map((option, optionIndex) => (
      option.Groups && (
        <div className="groups-table-container" key={optionIndex}>
          <h4>Groups for {option.Name}</h4>

          {/* Tab navigation for all groups */}
          <div className="groups-table-tab-navigation">
            {option.Groups.map((group, groupIndex) => (
              group.Charges.map((charge, chargeIndex) => (
                <button
                  key={chargeIndex}
                  onClick={() => handleTabChange(optionIndex, groupIndex, chargeIndex)}
                  className={`groups-table-tab-button ${activeTabs.optionIndex === optionIndex && activeTabs.groupIndex === groupIndex && activeTabs.chargeIndex === chargeIndex ? 'active' : ''}`}
                >
                  {group.Name} 
                </button>
              ))
            ))}
          </div>

          {/* Render only the active table */}
          <div className="groups-table-content">
            {option.Groups.map((group, groupIndex) => (
              group.Charges.map((charge, chargeIndex) => (
                activeTabs.optionIndex === optionIndex && activeTabs.groupIndex === groupIndex && activeTabs.chargeIndex === chargeIndex && (
                  <div key={chargeIndex} className="groups-table-tab-content active">
                    <table className="pricing-table">
                      <thead>
                        <tr>
                          <th>Charge Type</th>
                          <th>Quantity From</th>
                          <th>Quantity To</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {charge.Prices.map((price, priceIndex) => (
                          <tr key={priceIndex}>
                            <td>{charge.Type}</td>
                            <td>{price.Quantity.From}</td>
                            <td>{price.Quantity.To !== 2147483647 ? price.Quantity.To : 'Max Quantity'}</td>
                            <td>${price.Price}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )
              ))
            ))}
          </div>
        </div>
      )
    ))}


  </div>
)}


      
            {/* Display Services */}
            {product?.Imprinting?.Services?.Values && (
              <div>
                <h4>Available Services</h4>
                <ul>
                  {product.Imprinting.Services.Values.map((service, index) => (
                    <li key={index}>
                      {service.Name} - {service.Description || ''}
                      {service.Charges && service.Charges.length > 0 && (
                        <ul>
                          {service.Charges.map((charge, chargeIndex) => (
                            <li key={chargeIndex}>
                              {charge.Description}: {charge.Prices[0].Price} {charge.CurrencyCode} ({charge.PriceIncludes})
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
      
            {/* Render existing imprinting methods table */}
            {product?.Imprinting?.Methods?.Values && renderImprintTables(product.Prices)}
          </div>
        );
        case 'production-shipping':
          const fobPoints = product.Shipping?.FOBPoints?.Values || [];
          const shippingOptions = product.Shipping?.Options?.Values || [];
          const weightDetails = product.Shipping?.Weight?.Values || [];
          const dimensions = product.Shipping?.Dimensions || {};
          
          return (
            <div className="tab-content">
              <h4>FOB Points</h4>
              <table className="pricing-table">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Vendor Code</th>
                  </tr>
                </thead>
                <tbody>
                  {fobPoints.length > 0 ? (
                    fobPoints.map((point, index) => (
                      <tr key={index}>
                        <td>{point.Code}</td>
                        <td>{point.Name}</td>
                        <td>{point.VendorCode}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">No FOB Points available</td>
                    </tr>
                  )}
                </tbody>
              </table>
        
              <div>
                <h5>Shipping Options</h5>
                <table className="pricing-table">
                  <thead>
                    <tr>
                      <th>Option Name</th>
                      <th>Type</th>
                      <th>Description</th>
                      <th>Quantity From</th>
                      <th>Quantity To</th>
                      <th>Price</th>
                      <th>Cost</th>
                      <th>Discount Code</th>
                      <th>Currency Code</th>
                      <th>Vendor Code</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shippingOptions.length > 0 ? (
                      shippingOptions.map((option, optionIndex) => (
                        <tr key={optionIndex}>
                          <td>{option}</td> {/* Adjust this based on the actual structure of your shipping options */}
                          <td>—</td>
                          <td>—</td>
                          <td>—</td>
                          <td>—</td>
                          <td>—</td>
                          <td>—</td>
                          <td>—</td>
                          <td>—</td>
                          <td>—</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10">No shipping options available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
        
              <div>
                <h5>Shipping Details</h5>
                <table className="pricing-table">
                  <thead>
                    <tr>
                      <th>Weight</th>
                      <th>Weight Unit</th>
                      <th>Weight Per Package</th>
                      <th>Package Unit</th>
                      <th>Items Per Package</th>
                      <th>Dimensions</th>
                      <th>Bills By Weight</th>
                      <th>Bills By Size</th>
                      <th>Package In Plain Box</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{weightDetails.length > 0 ? weightDetails[0].Name : 'N/A'}</td>
                      <td>{product.Shipping?.WeightUnit || 'N/A'}</td>
                      <td>{product.Shipping?.WeightPerPackage || 'N/A'}</td>
                      <td>{product.Shipping?.PackageUnit || 'N/A'}</td>
                      <td>{product.Shipping?.ItemsPerPackage || 'N/A'}</td>
                      <td>{dimensions.Description || 'N/A'}</td>
                      <td>{product.Shipping?.BillsByWeight ? 'Yes' : 'No'}</td>
                      <td>{product.Shipping?.BillsBySize ? 'Yes' : 'No'}</td>
                      <td>{product.Shipping?.PackageInPlainBox ? 'Yes' : 'No'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          );
        
      case 'safety-compliance':
        return (
          <div className="tab-content">
            <p>Safety & Compliance details here.</p>
          </div>
        );
      default:
        return null;
    }
  };

  if (!product) {
    return null; // or a loading indicator
  }

  return (
<Modal
  isOpen={popupMode} 
  onRequestClose={onRequestClose}
  contentLabel="Product Customization"
  style={{
    overlay: {
      zIndex: 13000,
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)",
    },
    content: {
      zIndex: 13001,
      position: "absolute",
      inset: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      borderRadius: "4px",
      outline: "none",
      padding: "20px",
    },
  }}
>
      <div className="product-popup-container">
        <button className="close-button" onClick={onRequestClose}>×</button>
          <div className="product-details">
          <div className="tabs">
            <button onClick={() => setActiveTab('pricing')} className={activeTab === 'pricing' ? 'active' : ''}>Pricing</button>
            <button onClick={() => setActiveTab('product-detail')} className={activeTab === 'product-detail' ? 'active' : ''}>Product Detail</button>
            <button onClick={() => setActiveTab('imprint')} className={activeTab === 'imprint' ? 'active' : ''}>Imprint</button>
            <button onClick={() => setActiveTab('production-shipping')} className={activeTab === 'production-shipping' ? 'active' : ''}>Production & Shipping</button>
            <button onClick={() => setActiveTab('safety-compliance')} className={activeTab === 'safety-compliance' ? 'active' : ''}>Safety & Compliance</button>
        </div>
        <div className="tab-content-container">
          {renderTabContent()}
        </div>
      </div>

      <div className="product-creation-window">
        <div className="tab-buttons">
          <button onClick={() => setActiveProductTab('directSync')} className={activeProductTab === 'directSync' ? 'active' : ''}>Direct Sync Product</button>
          <button onClick={() => setActiveProductTab('customize')} className={activeProductTab === 'customize' ? 'active' : ''}>Customize Product</button>
          <button onClick={() => setActiveProductTab('edit')} className={activeProductTab === 'edit' ? 'active' : ''}>Edit Product</button>
        </div>

        {activeProductTab === 'directSync' && (
        <div className="product-direct-sync">
            <h3>Product Sync</h3>
            <span className="alert red"><b>BETA: </b> The following function allows you to sync the following product with the Elite Promo Marketing internal database. This is essential to ensure that the respective product has the latest data from ASI.</span>
            <button onClick={handleCreateProduct} className="submit-button" disabled>Sync Product</button>
        </div>
        )}


          {activeProductTab === 'customize' && (
            <div className="product-customization">
              <h3>Customize Product</h3>
              <span className="alert blue">This functionality allows users to create a personalized version of a product sourced from the ASI database. For example, if the database contains blank shirts, a business like an architecture firm can create a custom version of the shirt featuring their logo. These settings are saved, enabling quick repurchase without needing to recreate the customization each time.              </span>

              <div className="form-group">
                <label>Markup Price:</label>
                <input
                  type="number"
                  value={markupPrice}
                  onChange={(e) => setMarkupPrice(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Percentage Increase (%):</label>
                <input
                  type="number"
                  value={percentageIncrease}
                  onChange={(e) => setPercentageIncrease(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Base Increase (CAD):</label>
                <input
                  type="number"
                  value={baseIncrease}
                  onChange={(e) => setBaseIncrease(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Color:</label>
                <input
                  type="text"
                  value={selectedColor}
                  onChange={(e) => setSelectedColor(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Size:</label>
                <input
                  type="text"
                  value={selectedSize}
                  onChange={(e) => setSelectedSize(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Category:</label>
                <input
                  type="text"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Brand:</label>
                <input
                  type="text"
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Tags (comma-separated):</label>
                <input
                  type="text"
                  value={tags}
                  onChange={(e) => setTags(e.target.value)}
                />
              </div>
              <button onClick={handleCreateProduct} className="submit-button">Create Product</button>
            </div>
          )}


          {activeProductTab === "edit" && (
            <OrderEditExistingProduct 
              product={product} 
              productId={productId} 
              handleInputChange={handleInputChange} 
              handleSaveProduct={handleSaveProduct}
            />
          )}

        </div>
      </div>
    </Modal>
  );
}

export default ProductPopup;
